import { defineComponent as _defineComponent } from 'vue'
import { ref, watch } from 'vue';
import { useScrollTrigger } from '@/composables';

interface Props {
  items: string[];
  collapsiable?: boolean;
  shownItemsCount?: number;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'UiList',
  props: {
    items: null,
    collapsiable: { type: Boolean, default: false },
    shownItemsCount: { default: 6 }
  },
  setup(__props: any) {

const props = __props as { items: string[], collapsiable: boolean, shownItemsCount: number };



const { refresh } = useScrollTrigger();
const isCollapse = ref(true);
const toggleCollapse = () => {
  isCollapse.value = !isCollapse.value;
};

const isItemShown = (index: number): boolean => {
  if (!props.collapsiable) return true;
  if (
    (props.items.length || Object.entries(props.items).length) <=
    props.shownItemsCount
  )
    return true;
  if (index < props.shownItemsCount || !isCollapse.value) return true;
  return false;
};

watch(isCollapse, () => {
  setTimeout(() => {
    refresh();
  }, 200);
});

return { __sfc: true,props, refresh, isCollapse, toggleCollapse, isItemShown }
}

})